import { render } from "./LoyaltyTierBenefit.vue?vue&type=template&id=5d3ac7ec&scoped=true"
import script from "./LoyaltyTierBenefit.vue?vue&type=script&lang=js"
export * from "./LoyaltyTierBenefit.vue?vue&type=script&lang=js"

import "./LoyaltyTierBenefit.vue?vue&type=style&index=0&id=5d3ac7ec&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3ac7ec"]])

export default __exports__